import UICnProgress from './progress';
import './styles/index.scss';
var CnProgress = UICnProgress;
CnProgress.displayName = 'CnProgress';
export { CnProgress };
